/* eslint-disable no-nested-ternary */
import { Button, Input } from 'antd';

import { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import Icons from '../../../configs/icon.config';
import useChatSocket from '../hooks/useChatSocket';
import {
  commonState,
  setChatbotTextMessageDisabled,
  setChatbotStart,
} from '../../../app/base/commonSlice';

interface ChatbotFooterProps {
  // handleStartChat: (data: boolean) => void;
  // chatPage: boolean;
  // data?: any;
  // handleSocketResponse?: (data: any) => void;
  handleQuesId?: (data: any) => void;
  conversation?: any;
}

function ChatbotFooter({
  // handleStartChat,
  // data,

  handleQuesId,
  conversation,
}: ChatbotFooterProps) {
  const { chatbotTextMessageDisabled, isSearchButton, language, chatbotStart } =
    useSelector(commonState);
  // console.log(conversation);

  const [textInput, setTextInput] = useState('');
  // const [startChat, setStartChat] = useState(
  //   localStorage.getItem('startChat') === 'true'
  // );
  const { emitRequest } = useChatSocket();
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    // handleStartChat(true);
    // emitRequest({ question_id: 1 });
    // @ts-ignore
    handleQuesId(1);
    localStorage.setItem('startChat', 'true');
    // setStartChat(true);

    dispatch(setChatbotStart(true));
    // handleSocketResponse(socketResponse);
  }, [dispatch, handleQuesId]);

  const handleSend = () => {
    dispatch(setChatbotTextMessageDisabled(true));

    emitRequest({
      question_id: conversation[0]?.message[0]?.id,
      question_text: textInput,
    });
    setTextInput('');
  };

  // console.log(conversation);

  const handleInput = (event: any) => {
    setTextInput(event.target.value);
  };

  const input = useRef(null);

  setTimeout(() => {
    if (input.current) {
      // @ts-ignore
      input.current.focus();
    }
  }, 0);

  // console.log(textInput);
  return (
    <div className="pt-8">
      {chatbotStart ? (
        <div className="border-t-[1px] flex p-8">
          <Input
            disabled={chatbotTextMessageDisabled}
            className={`border-none mr-4 focus:border-none ${
              chatbotTextMessageDisabled ||
              conversation[0]?.message[0]?.answer_type === 'BUTTON'
                ? 'hidden'
                : 'block'
            }`}
            type="text"
            placeholder={
              isSearchButton
                ? language === 'en'
                  ? 'Type the name of your colleague and click the "Search" button'
                  : 'আপনার সহকর্মীর নাম লিখুন এবং "খুঁজুন" বাটনটি টিপুন'
                : language === 'en'
                ? 'Type and enter "Send" button to send message'
                : 'বার্তা পাঠাতে টাইপ করুন এবং "পাঠান" বাটনটি টিপুন'
            }
            onChange={handleInput}
            value={textInput}
            ref={input}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !isEmpty(textInput)) handleSend();
            }}
          />
          <Button
            className={`flex border-none text-[#EB3E8E] ${
              chatbotTextMessageDisabled ||
              conversation[0]?.message[0]?.answer_type === 'BUTTON'
                ? 'hidden'
                : 'block'
            }`}
            disabled={chatbotTextMessageDisabled || isEmpty(textInput)}
            onClick={handleSend}
          >
            <div className="mr-3 mt-1 ">
              {isSearchButton ? Icons.search : Icons.send}
            </div>
            {isSearchButton ? (
              <div>{language === 'en' ? 'Search' : 'খুঁজুন'}</div>
            ) : (
              <div> {language === 'en' ? 'Send' : 'পাঠান'}</div>
            )}
          </Button>
        </div>
      ) : (
        <div className="mx-12 mb-10">
          <Button
            className="h-[50px] flex justify-center text-white bg-[#EB3E8E] w-full rounded-none hover:text-black hover:bg-[#EB3E8E]"
            onClick={handleClick}
          >
            <div className="text-white hover:text-white mr-4 mt-[9px] text-[20px]">
              {Icons.feedback}
            </div>
            <div className="text-white hover:text-white mt-[6px] text-[20px]">
              {language === 'en' ? 'Start Chatting' : 'চ্যাটিং শুরু করুন'}
            </div>
          </Button>
        </div>
      )}
    </div>
  );
}

export default ChatbotFooter;
